import { CreateForm, FormFieldsData } from 'framework/form';
import { ShowSection } from 'framework/ui/layout';
import DavinciReportForm from './DavinciReportForm';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { useProjectId } from 'domain/shared/project';
import useCustomerReportService from '../useCustomerReportService';
import CustomerReportActionButtons from './CustomerReportActionButtons';
import { useProjectDetails } from 'domain/projects/newProject/dashboard/hooks/useProjectDashboard';
import { Loading } from 'framework/ui/mui-builder';
import { filterReportData } from '../utills';
import { Box } from '@mui/material';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import React from 'react';

const CreateCustomerReportLayout = () => {
  const id = useProjectId();
  const { getCustomerReportUrl } = useNewProjectUrl();
  const { createDraftReport, submitCustomerReport, contentReportSearch, getCustomerReportValidationSchema } =
    useCustomerReportService();
  const { project, isDataReloading } = useProjectDetails(id!);
  const { addMessage } = useMessageService();

  if (isDataReloading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Loading isInitialPosition />
      </Box>
    );
  }

  const reportFrequency = project?.settings?.reportSettings?.reportFrequency;
  const projectStartDate = project?.health?.createdAt;

  const submitPayload = (values: FormFieldsData) => ({
    periodStart: values.periodStart,
    periodEnd: values.periodEnd,
    template: values.template,
    businessOutcomes: values.businessOutcomes,
    milestones: values.milestones,
    risks: values.risks,
    changeRequests: values.changeRequests,
    projectId: id,
  });

  return (
    <CreateForm
      getDataFunc={async () => {
        const content = await contentReportSearch(id!, true, {});
        return filterReportData(content, reportFrequency, projectStartDate);
      }}
      submitFormFunc={async values =>
        values.isDraft
          ? createDraftReport(id!, submitPayload(values))
          : submitCustomerReport(id!, submitPayload(values))
      }
      handleErrorsOnSubmit={async response => {
        const errorR = await response.json();
        addMessage(new ErrorMessage(errorR.message));
      }}
      afterSubmit={{
        redirect: getCustomerReportUrl(id),
        message: 'You are awesome! Customer Report has been successfully updated.',
      }}
      getValidationSchemaFunc={getCustomerReportValidationSchema}
    >
      <ShowSection title="Add New Customer Report:" titleVariant="h2">
        <DavinciReportForm projectId={id!} reportFrequency={reportFrequency} projectStartDate={projectStartDate} />
        <CustomerReportActionButtons approvalType={project?.settings?.reportSettings?.approvalType} />
      </ShowSection>
    </CreateForm>
  );
};
export default CreateCustomerReportLayout;
